import { Component, OnInit, Input, Output } from "@angular/core";
import { Router } from "@angular/router";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AuthService } from "../../service/auth.service";
import { GeneralService } from "../../service/general.service";


@Component({
    selector: "i-icon-dialog",
    templateUrl: "../../../html/incs/i-dialog.html"
})
export class IIconDialog implements OnInit {
    public infoMessage:string = null!;

    constructor(public dialogRef: MatDialogRef<IIconDialog>,
    ) {}

    ngOnInit(): void {
    }

    closeDialog() {
      this.dialogRef.close(null!);
    }
}